import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, VOLATILITY} from "../MarginQuizQuestions";

export const Volatility = "tfVolatilityQuestion";

export function volatility() {
    return {
        templateUrl: "app/quiz/margin/questions/Volatility.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: VolatilityQuestionController
    };
}

export class VolatilityQuestionController extends MarginQuizQuestionController {
    public config = VOLATILITY;
}
